import { call, put, takeEvery } from 'redux-saga/effects';
import { createUserAPI, deleteUserAPI, getUserAPI, updateUserAPI } from "../Services"
import { ADD_USER, ADD_USER_RED, DELETE_USER, DELETE_USER_RED, GET_USER, GET_USER_RED, UPDATE_USER, UPDATE_USER_RED } from "../Constant"

// / Create Notifaction Saga
function* createUserSaga(action) {
    try {
        const response = yield call(createUserAPI, action.payload);
        if (response && response.data) {
            yield put({ type: ADD_USER_RED, data: response.data });
        } else {
            console.error("Create User API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in createUserSaga:", error);
    }
}

// Get Notifaction Saga
function* getUserSaga() {
    try {
        const response = yield call(getUserAPI);
        if (response && response.data) {
            yield put({ type: GET_USER_RED, data: response.data });
        } else {
            console.error("Get User API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in getUserSaga:", error);
    }
}

// Delete Notifaction Saga
function* deleteUserSaga(action) {
    try {
        const response = yield call(deleteUserAPI, action.payload);
        if (response) {
            yield put({ type: DELETE_USER_RED, data: action.payload });
        } else {
            console.error("Delete User API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in deleteUserSaga:", error);
    }
}

// Update Notifaction Saga
function* updateUserSaga(action) {
    try {
        const response = yield call(updateUserAPI, action.payload);
        if (response) {
            yield put({ type: UPDATE_USER_RED, data: action.payload });
        } else {
            console.error("Update User API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in updateUserSaga:", error);
    }
}

// Notifaction Saga (Watcher)
export function* userSaga() {
    yield takeEvery(ADD_USER, createUserSaga);
    yield takeEvery(GET_USER, getUserSaga);
    yield takeEvery(DELETE_USER, deleteUserSaga);
    yield takeEvery(UPDATE_USER, updateUserSaga);
}
